import React from "react";
import { useTranslation, Trans } from "react-i18next";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

// Trans component map is static JSX — hoisted so fresh object identity
// doesn't force Trans to re-reconcile every render.
const TRANS_COMPONENTS_UNDERLINE_RUST = { u: <u className="text-rust font-semibold" /> };

/**
 * ConfirmDeleteDialog — destructive confirmation for the exact-hash
 * duplicate flow (or single-scan delete). Uses <Trans> to underline
 * the target name in the description copy.
 */
export default function ConfirmDeleteDialog({ pending, onCancel, onConfirm }) {
  const { t } = useTranslation();
  return (
    <AlertDialog open={!!pending} onOpenChange={(o) => !o && onCancel()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display">
            {t("duplicates.confirmTitle")}
          </AlertDialogTitle>
          <AlertDialogDescription>
            <Trans
              i18nKey="duplicates.confirmDesc"
              values={{ name: pending?.label || "" }}
              components={TRANS_COMPONENTS_UNDERLINE_RUST}
            />
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="dup-confirm-cancel">
            {t("common.cancel")}
          </AlertDialogCancel>
          <AlertDialogAction
            data-testid="dup-confirm-delete"
            onClick={(e) => { e.preventDefault(); onConfirm(); }}
            className="bg-rust hover:bg-rust/90 font-bold uppercase tracking-wide"
          >
            {t("common.delete")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
